import styles from './PageLoader.less';

import React from 'react';
import { Loader } from 'seek-style-guide/react';

export default function PageLoader() {
  return (
    <div className={styles.root}>
      <Loader />
    </div>
  );
}
